<script>
	/**
	 * Howdy.
	 * This is a workaround.
	 * 
	 * See https://github.com/pngwn/MDsveX/issues/116
	 * 
	 * TLDR: TypeScript & SCSS Doesn't work directly in MDSveX.
	 * That's why we're wrapping everyhing in a wrapper.
	*/
	import Layout from "$lib/patterns/Layout.svelte";
	export let title = '';
	export let meta = {};
</script>

<Layout {title} {meta}>
	<slot />
</Layout>